import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface SnackBarPopupProps {
  severity: "success" | "error" | "warning" | "info";
  message: string | React.ReactNode;
  open: boolean;
  onClose: () => void;
  autoHideDuration?: number | null;
  verticalPosition?: "top" | "bottom";
}
const SnackBarPopup: React.FC<SnackBarPopupProps> = (props) => {
  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    props?.onClose();
    if (reason === "clickaway") {
      return;
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Snackbar
        open={props?.open}
        autoHideDuration={props?.autoHideDuration}
        onClose={handleClose}
        anchorOrigin={{
          vertical: props.verticalPosition ?? "bottom",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={handleClose}
          severity={props?.severity}
          variant="filled"
          elevation={6}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={{ width: "100%" }}
        >
          {props?.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SnackBarPopup;
